<template>
  <div class="app-container contact-us">
    <Block :title="$t('flashpay_customer_service')" class="info-block">
      <md-field>
        <md-field-item :title="$t('me_contact_number')" addon="+62 21-572-3257" />
        <md-field-item :title="$t('contact_email')" addon="cs-pay@flashfin.com" />
      </md-field>
    </Block>
    <div class="svervice-time">{{ $t('svervice_time') }}</div>
  </div>
</template>

<script>
import Block from '@/components/Block'
import { Field, FieldItem } from 'mand-mobile'
// 联系我们
export default {
  name: 'MeContactUs',
  components: {
    Block,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem
  }
}
</script>

<style lang='scss' scoped>
::v-deep .info-block {
  .flash-block__content {
    .flash-block_body {
      padding: 0;
    }
  }
}

.contact-us {
  ::v-deep .flash-block-title {
    color: #333;
    font-size: 28px;
    font-weight: 500;
    padding-left: 32px;
  }

  ::v-deep .flash-block__content {
    border-radius: 32px;
  }

  ::v-deep .md-field {
    padding: 4px 32px 0 32px;
    min-height: auto;
    border-radius: 32px;

    .md-field-item-content {
      align-items: start;
    }

    .md-field-item:last-child {
      .md-field-item-content::before {
        display: none;
      }
    }

    .md-field-item-right {
      color: #333;
      font-weight: 500;
      word-wrap: break-word;
      word-break: break-all;
    }

    .md-field-item-title {
      color: #7f7f7f;
      font-weight: 500;
      font-size: 28px;
    }
  }
}

.svervice-time {
  margin-top: 36px;
  width: 670px;
  text-align: center;
  color: #737373;
}
</style>
